import React, { useCallback, useMemo } from 'react';
import { SelectV1 } from '@withjoy/joykit';
import { DesktopContainer, styles } from './SortByPriceDesktop.styles';
import { useSortByPrice } from '../SortByPrice.controller';
import type { OptionType, SortByPriceArgs } from '../SortByPrice.types';

const SortByPriceDesktop = ({ value, onChange }: SortByPriceArgs) => {
  const { options } = useSortByPrice();

  const selectedOption = useMemo<Maybe<OptionType>>(() => {
    return (value && options.find(option => option.value === value)) ?? options[0];
  }, [options, value]);

  const handleDesktopChange = useCallback(
    (option: OptionType | null) => {
      if (option) {
        onChange?.(option.value);
      }
    },
    [onChange],
  );

  return (
    <DesktopContainer __css={styles.desktopContainer}>
      <SelectV1
        options={options}
        defaultValue={options[0]}
        value={selectedOption}
        onChange={handleDesktopChange}
        position="bottom"
        fluid={false}
        searchable={false}
        noBorder={true}
      />
    </DesktopContainer>
  );
};

export { SortByPriceDesktop };
